export const enum MethodTypes {
  PCIDSSBankCard = 'pci_dss_bank_card',
}
